import { GuidedTour, GuidedTourService, Orientation, TourStep } from 'ngx-guided-tour';

import { Injectable } from '@angular/core';
import { v4 as uuid } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class GuidedTourDataService {
  dashboardTourSteps: TourStep[] = [
    {
      selector: '#planning-card',
      title: 'Planning',
      content: 'Brings you to the Planning section where you can create, edit, share, and publish workouts.',
      orientation: Orientation.Bottom,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#group-management-card',
      title: 'Group Management',
      content: 'Brings you to the Group Management section where you can create and edit your groups.',
      orientation: Orientation.Bottom,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#explore-card',
      title: 'Explore',
      content: 'Brings you to the Explore section where you can view statistics relevant to your unit\s performance.',
      orientation: Orientation.Bottom,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#feedback-section',
      title: 'Feedback',
      content: 'Found an issue? Want to request a critical feature? Report it here.',
      orientation: Orientation.Top,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#main-menu-btn',
      title: 'End Guided Tour',
      content: 'End this tour at any time by selecting "Disable Guided Tour" from the dropdown menu.',
      orientation: Orientation.BottomLeft,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    }
  ];

  planLibraryTourSteps: TourStep[] = [
    {
      selector: '#plan-library',
      title: 'Plan Library',
      content: 'Here\'s your plan library. It consists of plans that either (1) you created or (2) have been shared with you.\nClick the 3-button menu for plan actions.',
      orientation: Orientation.Top,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#search-and-sort-plans',
      title: 'Searching Your Plans',
      content: 'The search capability makes finding your plan easier.',
      orientation: Orientation.Bottom,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#create-plan-button',
      title: 'Create a New Plan',
      content: 'Click here when ready to create a new plan.',
      orientation: Orientation.Top,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    }
  ];

  createPlanTourSteps: TourStep[] = [
    {
      selector: '#create-plan-form',
      title: 'Creating New Plans',
      content: 'You must fill in the first 3 fields in order to create a new plan.',
      orientation: Orientation.Bottom,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#checkmark-button',
      title: 'Save New Plan',
      content: 'When done, click here.',
      orientation: Orientation.TopRight,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    }
  ];

  planCalendarTourSteps: TourStep[] = [
    {
      selector: '#plan-level-menu',
      title: 'Plan Menu Options',
      content: 'Use this menu to edit, publish, share, copy, and print your plan.',
      orientation: Orientation.Left,
      action: () => { },
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#calendar',
      title: 'Adding Workouts to Your Plan',
      content: 'Hover over any day, then click the + sign that appears in the top right corner to add a workout.',
      orientation: Orientation.Right,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#calendar',
      title: 'Adding Phases to Your Plan',
      content: 'Click and drag between the desired start date and end date. After you release the mouse button, a pop-up will appear prompting you to add a phase.',
      orientation: Orientation.Right,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#mat-tab-label-0-0',
      title: 'Viewing Your Phases',
      content: 'Phases you add will appear here. The graph shows how much of your plan is devoted to each phase.',
      orientation: Orientation.Left,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#mat-tab-label-0-1',
      title: 'Viewing Your Workout and Tier Library',
      content: 'Your saved workouts and tiers are stored in your personal library.',
      orientation: Orientation.Left,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      title: 'Viewing Your Workout and Tier Library',
      content: 'To continue the tutorial, add your first workout to the calendar, then select it.',
      orientation: Orientation.Center,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    }
  ];

  workoutOverviewTourSteps: TourStep[] = [
    {
      selector: '#day-summary',
      title: 'Workout Overview',
      content: 'Here is the overview of your workout.',
      orientation: Orientation.Top,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#edit-workout-btn',
      title: 'Edit Button',
      content: 'Click "Edit" to configure the workout.',
      orientation: Orientation.Top,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#day-menu',
      title: 'Workout Menu Options',
      content: 'Use this menu to edit, copy, download, and add the workout to your personal plan library.',
      orientation: Orientation.TopLeft,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#complete-workout-btn',
      title: 'Mark Ready for Publishing',
      content: 'Click "Complete" to make this workout available to your users once the entire plan has been published.',
      orientation: Orientation.Top,
      action: () => {},
      closeAction: () => {},
      // TODO: set skipStep to false after "Complete" button is merged from USMC
      skipStep: true,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '',
      title: '',
      content: 'To continue the tour, click the "Edit" button.',
      orientation: Orientation.Center,
      action: () => {},
      closeAction: () => {},
      // TODO: set skipStep to false after "Complete" button is merged from USMC
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
  ];

  editWorkoutTourSteps: TourStep[] = [
    {
      selector: '#workout-name-field',
      title: 'Workout Name',
      content: 'Edit the name of your workout here for custom workouts.',
      orientation: Orientation.Bottom,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 500,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#est-completion-field',
      title: 'Estimated Completion Time',
      content: 'Estimate how long the workout should take.',
      orientation: Orientation.Right,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 400,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#est-rpe-field',
      title: 'Estimated RPE',
      content: 'Estimate the Rate of Perceived Exertion (RPE).',
      orientation: Orientation.Right,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 400,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#workout-tiers',
      title: 'Workout Tiers',
      content: 'These are the subsections of your workout.',
      orientation: Orientation.Right,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 500,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#tier-name-field',
      title: 'Tier Name',
      content: 'Edit the name of your tier here.',
      orientation: Orientation.Right,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 500,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#tier-notes-field',
      title: 'Tier Notes',
      content: 'Add notes to give your Marines more detailed instruction about the tier.',
      orientation: Orientation.Right,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 500,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#tier-circuit-controls',
      title: 'Tier Details',
      content: 'Here, specify whether the tier should be executed as a circuit, how many rounds to do, and how long to rest between circuits.',
      orientation: Orientation.Left,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 500,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '.exercise-row',
      title: 'Select An Exercise',
      content: 'Choose an exercise from the dropdown, or begin typing in the name of the exercise to locate it. Next, set any applicable options - reps, distance, etc.',
      orientation: Orientation.Top,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 500,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '.tier-step',
      title: 'Changing Tiers',
      content: 'Click on a tier to view it, or use these buttons to navigate through the list.',
      orientation: Orientation.TopLeft,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 700,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#add-to-lib-btn',
      title: 'Add Tier to Library',
      content: 'Click the "Add to Library" button to save a tier for reuse at a later time. ',
      orientation: Orientation.Left,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 500,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      title: 'Review The Workout',
      content: 'When done and ready to make the workout ready for publishing, click on the "Review" button available on the last tier.',
      orientation: Orientation.TopLeft,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 500,
      useHighlightPadding: true,
      highlightPadding: 5
    },
  ];

  exploreTourSteps: TourStep[] = [
    {
      selector: '#explore-tab-group',
      content: 'Here you can select an individual profile, a plan, or a group you own and view the training load stats in order to help inform you in your planning.',
      title: 'Training Load Analysis',
      orientation: Orientation.Right,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    }
  ];

  groupManagementTourSteps: TourStep[] = [
    {
      selector: '.mat-action-list',
      title: 'Group Library',
      content: 'Here you can select a group to view or edit the groups you own.',
      orientation: Orientation.Right,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#search-input',
      title: 'Searching Your Groups',
      content: 'The search capability makes finding your group easier.',
      orientation: Orientation.Bottom,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#create-group-button',
      title: 'Create a New Group',
      content: 'Click here when ready to create a new group.',
      orientation: Orientation.Bottom,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    }
  ];

  exerciseProgramTourSteps: TourStep[] = [
    {
      selector: 'exercise-selection-list',
      title: 'Exercise Library',
      content: 'Here you can select an exercise to view or edit (if admin). Click an exercise to view.',
      orientation: Orientation.Right,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#search-exercise-field',
      title: 'Searching the Exercises',
      content: 'The search capability makes finding an exercises easier.',
      orientation: Orientation.Bottom,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    },
    {
      selector: '#create-exercise-button',
      title: 'Create a New Exercise',
      content: 'Click here when ready to create a new exercise (if admin).',
      orientation: Orientation.Bottom,
      action: () => {},
      closeAction: () => {},
      skipStep: false,
      scrollAdjustment: 5,
      useHighlightPadding: true,
      highlightPadding: 5
    }
  ];


  exerciseProgramTour: GuidedTour = {
    tourId: uuid(),
    useOrb: false,
    steps: this.exerciseProgramTourSteps,
    skipCallback: (stepSkippedOn: number) => {},
    completeCallback: () => {},
  };

  groupManagementTour: GuidedTour = {
    tourId: uuid(),
    useOrb: false,
    steps: this.groupManagementTourSteps,
    skipCallback: (stepSkippedOn: number) => {},
    completeCallback: () => {},
  };

  exploreGuidedTour: GuidedTour = {
    tourId: uuid(),
    useOrb: false,
    steps: this.exploreTourSteps,
    skipCallback: (stepSkippedOn: number) => {},
    completeCallback: () => {},
  };

  dashboardGuidedTour: GuidedTour = {
    tourId: uuid(),
    useOrb: false,
    steps: this.dashboardTourSteps,
    skipCallback: (stepSkippedOn: number) => {},
    completeCallback: () => {},
  };

  planLibraryGuidedTour: GuidedTour = {
    tourId: uuid(),
    useOrb: false,
    steps: this.planLibraryTourSteps,
    skipCallback: (stepSkippedOn: number) => {},
    completeCallback: () => {},
  };

  createPlanGuidedTour: GuidedTour = {
    tourId: uuid(),
    useOrb: false,
    steps: this.createPlanTourSteps,
    skipCallback: (stepSkippedOn: number) => {},
    completeCallback: () => {},
  };

  planCalendarGuidedTour: GuidedTour = {
    tourId: uuid(),
    useOrb: false,
    steps: this.planCalendarTourSteps,
    skipCallback: (stepSkippedOn: number) => {},
    completeCallback: () => {},
  };

  workoutOverviewGuidedTour: GuidedTour = {
    tourId: uuid(),
    useOrb: false,
    steps: this.workoutOverviewTourSteps,
    skipCallback: (stepSkippedOn: number) => {},
    completeCallback: () => {},
  };

  editWorkoutGuidedTour: GuidedTour = {
    tourId: uuid(),
    useOrb: false,
    steps: this.editWorkoutTourSteps,
    skipCallback: (stepSkippedOn: number) => {},
    completeCallback: () => {},
  };




  constructor(private guidedTourService: GuidedTourService) { }

  startGuidedTour(page: string): void {
    this.guidedTourService.startTour(this.getGuidedTour(page));
  }

  getGuidedTour(page: string): GuidedTour {
    switch (page) {
      case 'dashboard':
        return this.dashboardGuidedTour;
      case 'plan-library':
        return this.planLibraryGuidedTour;
      case 'create-plan':
        return this.createPlanGuidedTour;
      case 'plan-calendar':
        return this.planCalendarGuidedTour;
      case 'workout-overview':
        return this.workoutOverviewGuidedTour;
      case 'edit-workout':
        return this.editWorkoutGuidedTour;
      case 'explore':
        return this.exploreGuidedTour;
      case 'group-management':
        return this.groupManagementTour;
      case 'exercise-program':
        return this.exerciseProgramTour;
      default:
        return this.dashboardGuidedTour;
    }
  }

  getTourSteps(page: string): TourStep[] {
    switch (page) {
      case 'dashboard':
        return this.dashboardTourSteps;
      case 'plan-library':
        return this.planLibraryTourSteps;
      case 'create-plan':
        return this.createPlanTourSteps;
      case 'plan-calendar':
        return this.planCalendarTourSteps;
      case 'workout-overview':
        return this.workoutOverviewTourSteps;
      case 'edit-workout':
        return this.editWorkoutTourSteps;
      case 'explore':
        return this.exploreTourSteps;
      case 'group-management':
        return this.groupManagementTourSteps;
      case 'exercise-program':
        return this.exerciseProgramTourSteps;
      default:
        return this.dashboardTourSteps;
    }
  }
}
